import React from "react";
/* Importación de iconos */
import { NavBar } from "../../../Components/Componentes_Propietario/navBar";


const MainPropietario = () => {
  return (
    <>
      <NavBar />
    </>
  );
};

export default MainPropietario;
